<template>
  <div class="product-image">
    <!-- <ProductDiscount :discount="content.bottlePricing" /> -->
    <router-link
      :to="path"
      class="product-link"
    >
      <div class="image-container">
        <div class="image">
          <AImage
            :img="image"
            :alt="title"
            :title="title"
            preset="wineproductteaser"
            contain
          />
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import carouselProductMixin from '../../mixins/carouselProductMixin'
import purchaseMixin from '@aspedia/vuejs-ecommerce-ui/mixins/item-purchase-qty.js'
import generalutils from '@aspedia/vuejs-ecommerce-ui/mixins/general-utils.js'

export default {
  name: 'carousel-product-list-image',
  mixins: [carouselProductMixin, purchaseMixin, generalutils]
}
</script>

<style lang="scss" scoped>
@import "../../styles/product-list-card-styles.scss";
</style>
